import React from 'react';
import { Helmet } from 'react-helmet';
import { Route, Switch } from 'react-router';
import { AI_UTILITIES } from '../constants/aiUtilities';
import { MarketPriceAnalysisLoader } from '../helpers/ai/marketPriceAnalysis/MarketPriceAnalysisLoader';
import { MarketPriceAnalysisViewer } from '../helpers/ai/marketPriceAnalysis/MarketPriceAnalysisViewer';
import { useTheme } from '../components/hooks/useTheme';
import './Shared.css';

export const MarketPriceAnalysis = () => {
    const { theme } = useTheme();

    const icon = theme === 'light' ? AI_UTILITIES.MARKET_PRICE_ANALYSIS.lightIcon : AI_UTILITIES.MARKET_PRICE_ANALYSIS.darkIcon;

    return (
        <div>
            <Helmet>
                <title>{AI_UTILITIES.MARKET_PRICE_ANALYSIS.name}</title>
            </Helmet>
            <div className="d-flex flex-row align-items-center mb-3">
                <img src={icon} alt="Логотип" className='title-icon mr-3' />
                <h4>{AI_UTILITIES.MARKET_PRICE_ANALYSIS.name}</h4>
            </div>
            <Switch>
                <Route exact path={AI_UTILITIES.MARKET_PRICE_ANALYSIS.path} component={MarketPriceAnalysisLoader} />
                <Route path={`${AI_UTILITIES.MARKET_PRICE_ANALYSIS.path}/:inputIdentifier`} component={MarketPriceAnalysisViewer} />
            </Switch>
        </div>
    );
};

MarketPriceAnalysis.displayName = 'MarketPriceAnalysis';